
import { Avatar, Box, Paper, Typography, styled } from '@mui/material';
import { BarChart } from '@mui/icons-material';
export interface GridItemProps {
  size: {
    xs: number;
    md: number;
  };
}

export const TabsContainer = styled(Paper)({
  width: '100%',
  padding: '12px',
  marginBottom: 3,
});

export const ProjectAvatar = styled(Avatar, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<{ isMobile: boolean }>(({ isMobile }) => ({
  width: isMobile ? '200px' : 156,
  height: isMobile ? 'auto' : 156,
  background: '#1B1C22',
  color: 'black',
  borderRadius: '8px',
}));

export const ProjectContainer = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<{ isMobile: boolean }>(({ isMobile }) => ({
  width: '100%',
  borderRadius: '8px',
  padding: '16px',
  display: 'flex',
  flexDirection: isMobile ? 'column' : 'row',
  alignItems: isMobile ? 'center' : 'flex-start',
  marginBottom: 3,
  marginTop: '0 !important',
}));

export const ProjectInfoContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<{ isMobile: boolean }>(({ isMobile }) => ({
  flexGrow: 1,
  marginLeft: isMobile ? 0 : 32,
  marginTop: isMobile ? 16 : 0,
  height: isMobile ? 'auto' : '155px',
  display: 'flex',
  alignItems: isMobile ? 'center' : 'flex-start',
  flexDirection: 'column',
  width: isMobile ? '100%' : 'auto',
}));

export const ProjectHeaderContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<{ isMobile: boolean }>(({ isMobile }) => ({
  display: 'flex',
  flexDirection: isMobile ? 'column' : 'row',
  justifyContent: 'space-between',
  width: '100%',
  alignItems: isMobile ? 'center' : 'flex-start',
}));

export const ProjectTitleContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<{ isMobile: boolean }>(({ isMobile }) => ({
  width: isMobile ? '100%' : 'auto',
  textAlign: isMobile ? 'center' : 'left',
  marginBottom: isMobile ? 16 : 0,
}));

export const ProjectTitleWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<{ isMobile: boolean }>(({ isMobile }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: isMobile ? 'center' : 'flex-start',
  flexWrap: 'wrap',
  gap: 8,
}));

export const ProjectTitle = styled(Typography)({
  color: 'white',
  fontWeight: 'bold',
});

export const ProjectId = styled(Typography)({
  color: '#aaa',
  marginTop: 4,
});

export const ButtonContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<{ isMobile: boolean }>(({ isMobile }) => ({
  marginLeft: isMobile ? 0 : 16,
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  width: isMobile ? '100%' : 'auto',
  justifyContent: isMobile ? 'center' : 'flex-start',
  marginBottom: isMobile ? 16 : 0,
}));

export const InfoBoxContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<{ isMobile: boolean }>(({ isMobile }) => ({
  display: 'flex',
  marginTop: isMobile ? 8 : 24,
  width: '100%',
  flexDirection: isMobile ? 'column' : 'row',
  gap: isMobile ? 8 : 0,
}));


export const NoDataContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  minHeight: 300,
  color: theme.palette.text.secondary,
  borderRadius: theme.shape.borderRadius,
  border: '1px dashed',
  borderColor: theme.palette.grey[600],
}));

export const NoDataIcon = styled(BarChart)(({ theme }) => ({
  fontSize: 64,
  color: theme.palette.grey[400],
  marginBottom: theme.spacing(2),
}));

export const NoDataTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: 500,
  marginBottom: theme.spacing(1),
}));

export const NoDataDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.disabled,
  textAlign: 'center',
  maxWidth: 280,
}));

export const SummaryChartContainer = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const GridItem = styled('div')<GridItemProps>(({ size }) => ({
  gridColumn: `span ${size.xs}`,
  '@media (min-width: 960px)': {
    gridColumn: `span ${size.md}`,
  }
}));

export const StyledPaper = styled(Paper)({
  padding: '24px',
  height: '100%',
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#fff',
});

export const ChipContainer = styled('div')({
  display: 'flex',
  gap: '8px',
});

export const GridContainer = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(12, 1fr)',
  gap: '16px',
  marginBottom: '16px',
  width: '100%',
});
